import { render, staticRenderFns } from "./AutocompleteSearch.vue?vue&type=template&id=0bce1644&scoped=true&"
import script from "./AutocompleteSearch.vue?vue&type=script&lang=js&"
export * from "./AutocompleteSearch.vue?vue&type=script&lang=js&"
import style0 from "./AutocompleteSearch.vue?vue&type=style&index=0&id=0bce1644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce1644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
